/* do not edit these settings */                                
var website_id = 81; 
var webapi_client_key = "fac51e32-5443-4cc3-a7f4-1ba9616cd5c8";
var text_personalize_button ="Personalize";
var text_cart_button ="Add to Cart";
var artifi_integration_url = "https://integrationdesigner.artifi.net";
var save_pdf_link =  "1";
var save_xml_link = "1";    
/* Please update below variables as per store theme */

/*
 * Set the Add to Cart Button Id Selector Here
 */
var artifiButtonAddToCart = 'button#AddToCart';

/*
 * Set the Span Selector having Add to Cart Button Text Here
 */
var artifiSpanAddToCartText = '#AddToCartText';

/*
 * Set the Id of Hidden Product Select Dropdown Here
 */
var artifiHiddenProductSelector = '#productSelect';

/*
 * Personali Button class
 */
var artifiPersonalizeButtonClass = "btn";

/*
 * Loads JQuery if not present
 * @param {type} url
 * @param {type} callback
 * @returns {undefined}
 */
function loadScript(url, callback) {

    var script = document.createElement("script")
    script.type = "text/javascript";

    if (script.readyState) {  //IE
        script.onreadystatechange = function () {
            if (script.readyState == "loaded" ||
                    script.readyState == "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  //Others
        script.onload = function () {
            callback();
        };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}

var artifiAppJavaScript = function ($) {
    $(document).ready(
            function () {
                var hideAddToCart = 0;
                /*
                 * Set Cart Button Text
                 */
                if ($(artifiButtonAddToCart).length) {
                    $(artifiSpanAddToCartText).text(text_cart_button);
                }
                /*
                 * Open the Personalzation Iframe
                 */
                if ($('#artifiIframeContainer').length) {
                    setInterval(function () {
                        if (typeof openPersonalizeIframe === "function") {
                            openPersonalizeIframe();
                        }
                    }, 1000);
                }
                /*
                 * Check if artifi product - and add personalize button
                 */
                if ($(artifiButtonAddToCart).length && $('#isArtifiProduct').length && $('#isArtifiProduct').val()) {
                    var myInterval = setInterval(
                            function () {
                                if (typeof artifi_app_api_key === "undefined") {
                                    // do nothing
                                } else {
                                    var issimple = '1';
                                    if ($('select' + artifiHiddenProductSelector + ' option').length > 1) {
                                        issimple = '0';
                                    }
                                    jQuery(artifiButtonAddToCart).after('<input type="hidden" name="artifiSku" id="artifiSku" value="' + meta.product.variants[0].sku + '"' +
                                            '/><input type="hidden" name="issimple" id="issimple" value="' + issimple + '"><button class="' + artifiPersonalizeButtonClass + '" id="artifiPersonalize" name="personalize" type="button">' +
                                            '<span id="artifiPersonalizeText">' + text_personalize_button + '</span>' +
                                            '</button>'
                                            );
                                    if ($('#isPersonalizationOptional').val() === '0') {
                                        hideAddToCart = 1;
                                        $(artifiButtonAddToCart).hide();
                                    }
                                    /*
                                     * Personalize button click event
                                     * Function to open new added personalization page by App installer
                                     */
                                    jQuery('button#artifiPersonalize').on('click', function (e) {
                                        e.preventDefault();
                                        var selectedSku = jQuery(artifiHiddenProductSelector + ' option:selected').attr('value');
                                        jQuery('#artifiSku').val(selectedSku);
                                        var idVal = $(artifiHiddenProductSelector).val();
                                        var artifiSkuVal = jQuery('#artifiSku').val();
                                        var isSimpleVal = jQuery('#issimple').val();
                                        var personalize_url = '/pages/Personalize?id=' + idVal + '&artifiSku=' + artifiSkuVal + '&issimple=' + isSimpleVal;

                                        // Get Prod Artifi Sku
                                        var artifiProductSku = jQuery('#artifiSku_0').val();
                                        if (artifiProductSku !== '') {
                                            personalize_url += '&artifiProductSku=' + artifiProductSku;

                                        }

                                        // Get Variant Artifi Sku
                                        var artifiVariantSku = jQuery('#artifiSku_' + selectedSku).val();
                                        if (artifiVariantSku !== '') {
                                            personalize_url += '&artifiVariantSku=' + artifiVariantSku;
                                        }
                                        window.location.href = personalize_url;
                                    });


                                    clearInterval(myInterval);
                                }
                            }, 1000
                            );
                }
                if (hideAddToCart === 0) {
                    jQuery(artifiButtonAddToCart).show();
                }
            }
    );
};

if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
    loadScript('//ajax.googleapis.com/ajax/libs/jquery/3.1.1/jquery.min.js', function () {
        jQuery311 = jQuery.noConflict(true);
        artifiAppJavaScript(jQuery311);
    });
} else {
    artifiAppJavaScript(jQuery);
}       